export const LEGAL_LINKS = {
  privacy: '/privacy-policy',
  terms: '/terms-of-service',
};
